import { Controller } from "@hotwired/stimulus"
import { track } from "../analytics/mixpanel"

// Drives the partner dashboard shell chrome: the mobile nav drawer, the partner
// switcher + account menu dropdowns, and the Partner Dashboard Nav event on nav
// clicks. Pure chrome interactivity — page content is its own React mount.
export default class extends Controller {
  static targets = ["drawer", "switcher", "switcherMenu", "acctMenu", "acctMenuMenu"]

  connect() {
    this.closeOnOutside = this.closeOnOutside.bind(this)
    document.addEventListener("click", this.closeOnOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
  }

  toggleDrawer() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.toggle("hidden")
  }

  closeDrawer() {
    if (this.hasDrawerTarget) this.drawerTarget.classList.add("hidden")
  }

  toggleSwitcher(event) {
    event.stopPropagation()
    if (this.hasSwitcherMenuTarget) this.switcherMenuTarget.classList.toggle("hidden")
  }

  toggleAcctMenu(event) {
    event.stopPropagation()
    if (this.hasAcctMenuMenuTarget) this.acctMenuMenuTarget.classList.toggle("hidden")
  }

  // Collapse the switcher/acct menu when clicking anywhere outside them.
  closeOnOutside(event) {
    if (
      this.hasSwitcherTarget &&
      this.hasSwitcherMenuTarget &&
      !this.switcherTarget.contains(event.target)
    ) {
      this.switcherMenuTarget.classList.add("hidden")
    }

    if (
      this.hasAcctMenuTarget &&
      this.hasAcctMenuMenuTarget &&
      !this.acctMenuTarget.contains(event.target)
    ) {
      this.acctMenuMenuTarget.classList.add("hidden")
    }
  }

  // Fires Partner Dashboard Nav (doc 09). Consent-gated and a no-op without a
  // Mixpanel token, so dev/test stay silent.
  track(event) {
    const toPage = event.currentTarget.dataset.toPage
    if (toPage) track("Partner Dashboard Nav", { to_page: toPage })
  }
}
